import ScrollWrapper from "../../../Components/ScrollWrapper";
import Text from "../../../Components/Text";
import SmallImage from "../../../Components/SmallImage";
import ChapterToggler from "../../../Components/ChapterToggler";

const EditWorkspaceDemo = () => {
    return (
        <ScrollWrapper>
            <div className="w-full h-full flex flex-col p-3 gap-4">
                <Text type="maintitle">Workspace Verwalten</Text>

                <Text type="itemtext">
                    Diese Seite ist nur für den <b>Eigentümer</b> des Workspaces verfügbar.
                    Hier können Name und weitere Workspace-Einstellungen angepasst werden.
                </Text>

                <SmallImage src={"instructions/workspace-main.png"} />

                {/* Übersicht */}
                <div className="w-full flex flex-col">
                    <Text type="title">Workspace Einstellungen</Text>
                </div>

                {/* Workspace Einstellungen */}
                <ChapterToggler title="Workspace Einstellungen">
                    <Text type="itemtext">
                        Hier können folgende Einstellungen definiert werden:
                    </Text>

                    <br />

                    <Text type="itemtext">
                        <b>Workspace Name:</b> Name des Workspaces
                    </Text>

                    <Text type="itemtext">
                        <b>Küchenmonitor aktivieren:</b> Aktiviert oder deaktiviert den Küchenmonitor.
                        Falls deaktiviert, werden Bestellungen direkt abgeschlossen und der
                        Küchenmonitor wird nicht angezeigt.
                    </Text>

                    <Text type="itemtext">
                        <b>Kartenzahlung zulassen:</b> Falls aktiviert, kann über die Android-App
                        von Cashier One eine Verbindung zu einem SumUp-Konto hergestellt werden.
                        Danach erscheint die Kartenzahl-Option am Kassenterminal.
                    </Text>

                    <Text type="itemtext">
                        <b>Workspace löschen:</b> Löscht den gesamten Workspace.
                        <br />
                        <b>⚠️ Warnung:</b> Diese Aktion ist nur noch über den Support rückgängig zu machen.
                    </Text>
                </ChapterToggler>
            </div>
        </ScrollWrapper>
    );
};

export default EditWorkspaceDemo;
